export default "__VITE_PUBLIC_ASSET__9360734a__"